module.exports = __webpack_public_path__ + "static/installer-0d29f4ed12e7cd285497fef4ecd20e5b.png";